/* eslint-disable no-useless-constructor */
/**
 * Classe de configuração de ambiente do Gabinete Eletrônico
 *
 * @class Configuracao
 */
class Configuracao {
  static DEFAULT_AXIOS_TIMEOUT = 12000000;

  // Instancia local para singleton
  static _c;

  /**
   * Recupera instancia de Configuração de modo unificado
   *
   * @static
   * @returns {Configuracao} Configuracao
   *
   * @memberof Configuracao
   */
  static getConfiguracao () {
    if (Configuracao._c === undefined) {
      Configuracao._c = new Configuracao();
    }
    return Configuracao._c;
  }

  constructor () {
  }

  set ambiente (config) {
    this.config = config;
    if (this.config === undefined) {
      throw new Error('Configuração de ambiente.json não encontrada.');
    }
  }

  get configuracao () {
    return this.config;
  }

  get urlLogin () {
    return this.config.sso + '/ms-autenticacao/tokens';
  }

  get urlVersaoSistema () {
    return this.config.api + '/publico/versao';
  }

  get urlChangelogConsultar () {
    return this.config.api + '/publico/changelog/consultar';
  }

  get urlChangelogContar () {
    return this.config.api + '/publico/changelog/contar_novidades';
  }
  get urlChangelogAtualizarCookie () {
    return this.config.api + '/publico/changelog/atualizar_cookie';
  }
  get urlBeneficiarioConsultarFluxo () {
    return this.config.api + '/beneficiario/entrou_saiu_plano/tipo_consulta';
  }
  get urlPensionistaConsultarFluxo () {
    return this.config.api + '/pensionista/cadastrado_cancelado/tipo_consulta';
  }
  get urlBeneficiarioConsultar () {
    return this.config.api + '/beneficiario/';
  }
  get urlHistoricoAdesaoConsultar () {
    return this.config.api + '/beneficiario/historico/adesao/';
  }
  get urlIncluirTitular () {
    return this.config.api + '/beneficiario/incluir_titular';
  }
  get urlIncluirDependente () {
    return this.config.api + '/beneficiario/incluir_dependente';
  }
  get urlExcluirTitular () {
    return this.config.api + '/beneficiario/excluir_titular';
  }
  get urlExcluirDependente () {
    return this.config.api + '/beneficiario/excluir_dependente';
  }
  get urlAlterarTitularidade () {
    return this.config.api + '/beneficiario/alterar_titularidade/';
  }
  get urlConsultarDependencias () {
    return this.config.api + '/beneficiario/consultar_dependencias/';
  }
  get urlSalvarDataInicial () {
    return this.config.api + '/beneficiario/salvar_data_inicial/';
  }
  get urlSalvarDataFim () {
    return this.config.api + '/beneficiario/salvar_data_fim/';
  }
  get urlConsultarLimitesDataInicioTitular () {
    return this.config.api + '/beneficiario/consultar_datas_inicio_limite_titular/';
  }
  get urlConsultarLimitesDataInicioDependente () {
    return this.config.api + '/beneficiario/consultar_datas_inicio_limite_dependente/';
  }
  get urlConsultarLimitesDataFimTitular () {
    return this.config.api + '/beneficiario/consultar_datas_fim_limite_titular/';
  }
  get urlConsultarLimitesDataFimDependente () {
    return this.config.api + '/beneficiario/consultar_datas_fim_limite_dependente/';
  }
  get urlConsultarNomesTodosBeneficiarios () {
    return this.config.api + '/beneficiario/nomes';
  }
  get urlTelefonesBeneficiario () {
    return this.config.api + '/beneficiario/consultar/telefone/';
  }
  get urlHistoricosBeneficiario () {
    return this.config.api + '/beneficiario/consultar/historico/';
  }
  get urlEmailsBeneficiario () {
    return this.config.api + '/beneficiario/consultar/email/';
  }
  get urlEnderecosBeneficiario () {
    return this.config.api + '/beneficiario/consultar/endereco/';
  }
  get urlRequisitadoBeneficiario () {
    return this.config.api + '/beneficiario/consultar/requisitado/';
  }
  get urlRequisitadoHistBeneficiario () {
    return this.config.api + '/beneficiario/consultar/requisitado_historico/';
  }
  get urlParametroConsultarParametro () {
    return this.config.api + '/parametro_sistema/consultar';
  }
  get urlUpdateParametro () {
    return this.config.api + '/parametro_sistema/alterar/codParametro';
  }
  get urlEstruturaCredito () {
    return this.config.api + '/credito/recuperar/estrutura';
  }
  get urlConsultarCreditos () {
    return this.config.api + '/credito';
  }
  get urlCancelarCredito () {
    return this.config.api + '/credito/cancelar';
  }
  get urlDesfazerCancelamentoCreditoUrl () {
    return this.config.api + '/credito/desfazer_cancelamento';
  }
  get urlExcluirCredito () {
    return this.config.api + '/credito/excluir';
  }
  get urlIncluirCredito () {
    return this.config.api + '/credito/incluir';
  }
  get urlAlterarCredito () {
    return this.config.api + '/credito/alterar';
  }
  get urlValidarCredito () {
    return this.config.api + '/credito/validar';
  }
  get urlCarenciaConsultar () {
    return this.config.api + '/carencia/consultar';
  }
  get urlCarenciaSalvar () {
    return this.config.api + '/carencia/salvar';
  }
  get urlExtratoResumidoConsultar () {
    return this.config.api + '/extrato_coparticipacao/consulta/resumido/';
  }
  get urlExtratoBeneficiarioConsultar () {
    return this.config.api + '/extrato_coparticipacao/consulta/beneficiario/';
  }
  get urlExtratoPrestadorConsultar () {
    return this.config.api + '/extrato_coparticipacao/consulta/prestador/';
  }
  get urlExtratoProcedimentoConsultar () {
    return this.config.api + '/extrato_coparticipacao/consulta/procedimento/';
  }
  get urlExtratoDataInicioAdesao () {
    return this.config.api + '/extrato_coparticipacao/consulta/dataReferencia/';
  }
  get urlExtratoDividaEmAberto () {
    return this.config.api + '/dividas_em_aberto/';
  }

  get urlExtratoDividaEmAbertoBeneficiario () {
    return this.config.api + '/extrato_coparticipacao/consulta/divida_em_aberto/beneficiario/';
  }
  get urlExtratoDividaEmAbertoProcedimento () {
    return this.config.api + '/extrato_coparticipacao/consulta/divida_em_aberto/procedimento/';
  }
  get urlConsultarDividaPorCarteira () {
    return this.config.api + '/extrato_coparticipacao/consulta/divida_em_aberto/procedimento/carteira/';
  }
  get isFolhaFechadaUrl () {
    return this.config.api + '/extrato_coparticipacao/folhaFechada';
  }
  get getDataUltimoFechamentoFolhaURL () {
    return this.config.api + '/extrato_coparticipacao/data_fechamento_folha';
  }
  get urlExtratoMensalidadeResumidoConsultar () {
    return this.config.api + '/extrato_mensalidade/consulta/resumido/';
  }
  get urlExtratoMensalidadeBeneficiarioConsultar () {
    return this.config.api + '/extrato_mensalidade/consulta/beneficiario/';
  }
  get urlExtratoMensalidadeCompletoConsultar () {
    return this.config.api + '/relatorio/mensalidade/completo';
  }
  get urlExtratoCoparticipacaoCompletoConsultar () {
    return this.config.api + '/relatorio/coparticipacao/completo';
  }
  get urlExtratoDividaCompletoConsultar () {
    return this.config.api + '/relatorio/dividas_detalhado/completo';
  }
  get urlConsultarProcedimentosTitulares () {
    return this.config.api + '/relatorio/calculo_atuarial/despesas/procedimento/titular/';
  }
  get urlConsultarProcedimentosDependentes () {
    return this.config.api + '/relatorio/calculo_atuarial/despesas/procedimento/dependente/';
  }
  get urlConsultarOpmesTitulares () {
    return this.config.api + '/relatorio/calculo_atuarial/despesas/opme/titular/';
  }
  get urlConsultarOpmesDependentes () {
    return this.config.api + '/relatorio/calculo_atuarial/despesas/opme/dependente/';
  }
  get urlConsultarDespesasTitulares () {
    return this.config.api + '/relatorio/calculo_atuarial/despesas/despesa/titular/';
  }
  get urlConsultarDespesasDependentes () {
    return this.config.api + '/relatorio/calculo_atuarial/despesas/despesa/dependente/';
  }
  get urlConsultarCalculoPrestadores () {
    return this.config.api + '/relatorio/calculo_atuarial/prestadores/';
  }
  get urlConsultarCalculoUsuarios () {
    return this.config.api + '/relatorio/calculo_atuarial/usuarios/';
  }
  get urlConsultarCalculoReceitas () {
    return this.config.api + '/relatorio/calculo_atuarial/receitas/';
  }
  get urlConsultarCalculoReembolsos () {
    return this.config.api + '/relatorio/calculo_atuarial/reembolsos/';
  }
  get urlConsultarCovidAutorizacao () {
    return this.config.api + '/relatorio/calculo_atuarial/covid_autorizacao/';
  }
  get urlConsultarCovidFaturamento () {
    return this.config.api + '/relatorio/calculo_atuarial/covid_faturamento/';
  }  
  get urlBairrosPrestadoresConsultar () {
    return this.config.api + '/publico/prestador/bairros';
  }
  get urlNomesPrestadoresConsultar () {
    return this.config.api + '/publico/prestador/nomes';
  }
  get urlConsultarNomesTodosPrestadores () {
    return this.config.api + '/prestador_consultar/nomes';
  }
  get urlConsultarNomesTodosPrestadoresCredenciados () {
    return this.config.api + '/prestador_consultar/nomes/credenciados';
  }
  get urlConsultarNomesTodosGrupos () {
    return this.config.api + '/prestador_grupo/nomes';
  }
  get urlConsultarNomesGruposPorTipo () {
    return this.config.api + '/prestador_grupo/nomes/';
  }
  get urlEspecialidadesPrestadoresConsultar () {
    return this.config.api + '/publico/prestador/especialidades';
  }
  get urlValidarArquivo () {
    return this.config.api + '/validacao/previa/validar';
  }
  get urlAuditarArquivo () {
    return this.config.api + '/validacao/previa/auditar';
  }
  get urlConsultarParametrosEnvio () {
    return this.config.api + '/validacao/previa/consultar';
  }
  get enviarArquivoUrl () {
    return this.config.api + '/validacao/previa/interno';
  }
  get urlConsultarProtocolo () {
    return this.config.api + '/protocolo/consultar/';
  }
  get urlListarProtocolos () {
    return this.config.api + '/protocolo/listar/numProtocolo/';
  }
  get urlAbrirXml () {
    return this.config.api + '/validacao/previa/abrir/xml/';
  }
  get urlConsultarLotesPorEstadoProtocolo () {
    return this.config.api + '/lote?status=';
  }
  get urlConsultarLotesPorPrestadorOuCodigoFatura () {
    return this.config.api + '/lote/prestador/';
  }
  get consultarLotesPrestadorCodigoStatus () {
    return this.config.api + '/lote/prestador/';
  }
  get urlConsultarFaturasPorNumGuiaPrestador () {
    return this.config.api + '/lote/numGuiaPrestador';
  }
  get urlSalvarDtaRecebimentoProcessoFisicoEmLote () {
    return this.config.api + '/lote/';
  }
  get urlConsultarGuiasDoLote () {
    return this.config.api + '/lote/';
  }
  get urlConsultarLote () {
    return this.config.api + '/lote';
  }
  get urlDesfazerAuditoriaGuia () {
    return this.config.api + '/auditoria/fatura/guia/desfazer';
  }
  get urlAuditarAutomaticamenteGuia () {
    return this.config.api + '/auditoria/fatura/guia/auditarAutomaticamente';
  }
  get urlAutorizarGuia () {
    return this.config.api + '/auditoria/fatura/guia/autorizar';
  }
  get urlGlosarGuia () {
    return this.config.api + '/auditoria/fatura/guia/glosar';
  }
  get urlDesfazerFaturasEmLote () {
    return this.config.api + '/auditoria/faturas/desfazer';
  }
  get urlFinalizarFaturasEmLote () {
    return this.config.api + '/auditoria/faturas/finalizar';
  }
  get urlAuditarAutomaticamenteFaturasEmLote () {
    return this.config.api + '/auditoria/faturas/auditarAutomaticamente';
  }
  get urlFinalizarAvaliacaoFaturasCNU () {
    return this.config.api + '/auditoria/faturas/finalizar_avaliacao_cnu';
  }
  get urlDevolverFaturasTstEmLote () {
    return this.config.api + '/auditoria/faturas/devolver_tst';
  }
  get urlEnviarFaturasCnuEmLote () {
    return this.config.api + '/auditoria/faturas/enviar_cnu';
  }
  get urlAuditarFaturasEmLote () {
    return this.config.api + '/auditoria/faturas/auditar';
  }
  get urlLiberarFaturasEmLote () {
    return this.config.api + '/lote/status/fatura/analisadas';
  }
  get urlNegarAuditoriaEmLote () {
    return this.config.api + '/lote/status/fatura/negarAuditoria';
  }
  get urlCancelarFaturasEmLote () {
    return this.config.api + '/lote/cancelar_lotes/motivo/';
  }
  get urlExcluirFaturasEmLote () {
    return this.config.api + '/lote/excluir_lotes/cpfCnpj/';
  }
  get urlConsultarGuia () {
    return this.config.api + '/lote/';
  }
  get urlConsultarDetalhesGuia () {
    return this.config.api + '/lote/';
  }
  get urlConsultarGuiaOriginal () {
    return this.config.api + '/lote/';
  }
  get urlConsultarGuiasSolicitacao () {
    return this.config.api + '/lote/';
  }
  get urlConsultarGuiasDuplicadas () {
    return this.config.api + '/lote/';
  }
  get urlCodigoENumeroFaturas () {
    return this.config.api + '/lote/fatura/nomes';
  }
  get urlConsultarTiposAtendimento () {
    return this.config.api + '/publico/tipoAtendimento';
  }
  get urlConsultarCaraterSolicitacao () {
    return this.config.api + '/carater_solicitacao/';
  }
  get urlBeneficiarioInternado () {
    return this.config.api + '/publico/tipoAtendimento/consultar_internacao/carteira/';
  }
  get urlConsultarTiposSituacaoServidor () {
    return this.config.api + '/tipo_situacao';
  }
  get urlConsultarElementos () {
    return this.config.api + '/lote/';
  }
  get urlUsuarioAplicacao () {
    return this.config.api + '/user';
    // return this.config.api + '/usuario';
  }
  // get urlIsUsuarioPrestador () {
  //   return this.config.api + '/usuario/isPrestador';
  // }
  // get urlRecuperarPrestador () {
  //   return this.config.api + '/usuario/prestador';
  // }
  get urlConsultarDividasEmAberto () {
    return this.config.api + '/dividas_em_aberto';
  }
  get urlConsultarDividasEmAbertoAsync () {
    return this.config.api + '/dividas_em_aberto/async';
  }
  get urlConsultarMotivosDeGlosa () {
    return this.config.api + '/glosa/consultar_motivos';
  }
  get urlSalvarAuditoriaElemento () {
    return this.config.api + '/auditoria/elemento/salvar';
  }
  get urlAceitarAuditoriaElementoCNU () {
    return this.config.api + '/auditoria/elemento/cnu/aceitar/';
  }
  get urlExcluirElementoCNU () {
    return this.config.api + '/auditoria/elemento/cnu/excluir/';
  }
  get urlRejeitarGlosaTST () {
    return this.config.api + '/auditoria/elemento/cnu/rejeitar/';
  }
  get urlDesfazerAvaliacaoElementoCNU () {
    return this.config.api + '/auditoria/elemento/cnu/desfazer/';
  }
  get urlAceitarAditoriaElementosNaoAvaliados () {
    return this.config.api + '/auditoria/elementos/cnu/aceitar/';
  }
  get urlExcluirElementosNaoAvaliados () {
    return this.config.api + '/auditoria/elementos/cnu/excluir/';
  }
  get urlDesfazerAvaliacaoElementos () {
    return this.config.api + '/auditoria/elementos/cnu/desfazer/';
  }
  get urlAjustarGlosasElementosDaGuiaCnu () {
    return this.config.api + '/auditoria/elementos/cnu/ajustar_glosas/';
  }
  get urlAlterarTipoAtendimentoSpsadt () {
    return this.config.api + '/lote/';
  }
  get urlAlterarCaraterSolicitacao () {
    return this.config.api + '/lote/';
  }
  get urlSalvarParecerAuditoria () {
    return this.config.api + '/lote/';
  }
  get urlSalvarMotivoGlosaGuia () {
    return this.config.api + '/glosa/guia/adicionar_motivo';
  }
  get urlGruposPrestadores () {
    return this.config.api + '/prestador_grupo/0/descricao/';
  }
  get urlExcluirGrupo () {
    return this.config.api + '/prestador_grupo/excluir/emLote';
  }
  get urlIncluirGrupo () {
    return this.config.api + '/prestador_grupo/incluir';
  }
  get urlAlterarGrupo () {
    return this.config.api + '/prestador_grupo/alterar';
  }
  get urlPrestadoresVinculados () {
    return this.config.api + '/prestador_grupo/consultar_prestadores/';
  }
  get urlPrestadoresDesvinculados () {
    return this.config.api + '/prestador_grupo/prestadores_desvinculados/';
  }
  get urlVincularPrestadoresEmLote () {
    return this.config.api + '/prestador_grupo/vincular_prestadores';
  }
  get urlDesvincularPrestadoresEmLote () {
    return this.config.api + '/prestador_grupo/desvincular_prestadores';
  }
  get urlPrestador () {
    return this.config.api + '/prestador_consultar/';
  }  
  get urlPrestadorSemOrgaoExterno () {
    return this.config.api + '/prestador_consultar/orgao_externo';
  }
  get urlEnderecosPrestador () {
    return this.config.api + '/prestador_consultar/enderecos/codPrestador/';
  }
  get urlConsultarCeps () {
    return this.config.api + '/cep/';
  }
  get urlTiposDeTelefone () {
    return this.config.api + '/telefone/tipos';
  }
  get urlConsultarEnderecoPorCep () {
    return this.config.api + '/cep/endereco/';
  }
  get urlIncluirEndereco () {
    return this.config.api + '/prestador/endereco/incluir';
  }
  get urlAlterarEndereco () {
    return this.config.api + '/prestador/endereco/alterar';
  }
  get urlExcluirEnderecos () {
    return this.config.api + '/prestador/endereco/excluir';
  }
  get urlConsultarEspecialidadesDoPrestador () {
    return this.config.api + '/prestador_consultar/especialidades/codPrestador/';
  }
  get urlConsultarEspecialidadesNaoVinculadasAoPrestador () {
    return this.config.api + '/prestador_consultar/especialidades/naoVinculadas/codPrestador/';
  }
  get urlVincularEspecialidades () {
    return this.config.api + '/prestador/especialidade/vincular/';
  }
  get urlDesincularEspecialidades () {
    return this.config.api + '/prestador/especialidade/desvincular/';
  }
  get urlConsultarPrestadorCredenciamento () {
    return this.config.api + '/prestador_consultar/credenciamento/codPrestador/';
  }
  get salvarDataInicialPrestadorUrl () {
    return this.config.api + '/prestador/salvar_data_inicial/';
  }
  get salvarDataFimPrestadorUrl () {
    return this.config.api + '/prestador/salvar_data_final/';
  }
  get urlExcluirCredenciamentos () {
    return this.config.api + '/prestador/credenciamento/excluir';
  }
  get urlIncluirCredenciamento () {
    return this.config.api + '/prestador/credenciamento/incluir';
  }
  get urlAlterarCredenciamento () {
    return this.config.api + '/prestador/credenciamento/alterar';
  }
  get urlValidarCredenciamento () {
    return this.config.api + '/prestador/credenciamento/validar/';
  }
  get urlTelefonesPrestador () {
    return this.config.api + '/prestador_consultar/telefones/codPrestador/';
  }
  get urlIncluirTelefone () {
    return this.config.api + '/prestador/telefone/incluir';
  }
  get urlAlterarTelefone () {
    return this.config.api + '/prestador/telefone/alterar';
  }
  get urlExcluirTelefones () {
    return this.config.api + '/prestador/telefone/excluir';
  }
  get urlIncluirPrestador () {
    return this.config.api + '/prestador/incluir';
  }
  get urlAlterarPrestador () {
    return this.config.api + '/prestador/alterar';
  }  
  get urlVincularPrestadorOrgaoExterno () {
    return this.config.api + '/prestador/vincular_orgao_externo/';
  }
  get urlExcluirPrestadores () {
    return this.config.api + '/prestador/excluir';
  }
  get urlConsultarOrgaosExternos () {
    return this.config.api + '/orgao_externo/listar';
  }
  get urlConsultarBancos () {
    return this.config.api + '/banco/listar';
  }
  get urlConsultarUfs () {
    return this.config.api + '/UF/nomes';
  }
  get urlConsultarDemonstrativos () {
    return this.config.api + '/demonstrativo/listar';
  }
  get urlConsultarDemonstrativosPorFiltro () {
    return this.config.api + '/demonstrativo/consultar/';
  }
  get urlConsultarDemonstrativosNaoPagos () {
    return this.config.api + '/calculoCoparticipacao/consultar_nao_pagos/';
  }
  get urlConsultarDemonstrativosNaoPagosOdonto () {
    return this.config.api + '/calculoCoparticipacao/consultar_nao_pagos_odonto/';
  }
  get urlConsultarTodosProcedimentos () {
    return this.config.api + '/calculoCoparticipacao/consultar_procedimentos';
  }
  get urlCalcularCoparticipacao () {
    return this.config.api + '/calculoCoparticipacao/calcular/';
  }
  get urlCalcularCoparticipacaoOdonto () {
    return this.config.api + '/calculoCoparticipacao/calcular_odonto/';
  }
  get urlLancarCoparticipacao () {
    return this.config.api + '/calculoCoparticipacao/lancar';
  }
  get urlAlterarDemonstrativo () {
    return this.config.api + '/demonstrativo/alterar';
  }
  get urlConsultarGrafico () {
    return this.config.api + '/demonstrativo/';
  }
  get urlConsultarAgencias () {
    return this.config.api + '/agencia/listar/';
  }
  get urlConsultarProcessos () {
    return this.config.api + '/processo/listar/';
  }
  get urlConsultarContratos () {
    return this.config.api + '/contrato/listar/';
  }
  get urlConsultarAnosProcessos () {
    return this.config.api + '/processo/listar/anos';
  }
  get urlConsultarAnosContratos () {
    return this.config.api + '/contrato/listar/anos';
  }
  get urlProdutividadeFaturasPorMes () {
    return this.config.api + '/produtividade_auditoria/mensal/fatura';
  }
  get urlProdutividadeGuiasPorMes () {
    return this.config.api + '/produtividade_auditoria/mensal/guia';
  }
  get urlProdutividadeElementosPorMes () {
    return this.config.api + '/produtividade_auditoria/mensal/elemento';
  }
  get urlConsultarNomesTodosProfissionais () {
    return this.config.api + '/profissional/nomes';
  }
  get urlConsultarEspecialidades () {
    return this.config.api + '/profissional/especialidades';
  }
  get urlConsultarEspecialidadesPermitidas () {
    return this.config.api + '/profissional/especialidadesPermitidas/';
  }
  get urlConsultarCROs () {
    return this.config.api + '/profissional/CROs';
  }
  get urlConsultarProfissionais () {
    return this.config.api + '/profissional/profissionais/';
  }
  get urlIncluirProfissional () {
    return this.config.api + '/profissional/incluir';
  }
  get urlExcluirProfissional () {
    return this.config.api + '/profissional/excluir';
  }
  get urlAlterarProfissional () {
    return this.config.api + '/profissional/alterar';
  }
  get urlValidarProfissional () {
    return this.config.api + '/profissional/validar';
  }
  get urlConsultarFaixasRemuneracao () {
    return this.config.api + '/faixa_remuneracao/consultar/';
  }
  get urlExcluirFaixaRemuneracao () {
    return this.config.api + '/faixa_remuneracao/excluir';
  }
  get urlAlterarFaixaRemuneracao () {
    return this.config.api + '/faixa_remuneracao/alterar';
  }
  get urlIncluirFaixaRemuneracao () {
    return this.config.api + '/faixa_remuneracao/incluir';
  }
  get urlValidarFaixaRemuneracao () {
    return this.config.api + '/faixa_remuneracao/validar/';
  }  
  get urlConsultarVigencias () {
    return this.config.api + '/vigencia_porte_anestesico/consultar/';
  }  
  get urlConsultarPortes () {
    return this.config.api + '/vigencia_porte_anestesico/consultar_portes';
  }  
  get urlValidarVigencia () {
    return this.config.api + '/vigencia_porte_anestesico/validar/';
  }  
  get urlIncluirVigencia () {
    return this.config.api + '/vigencia_porte_anestesico/incluir';
  }
  get urlAlterarVigencia () {
    return this.config.api + '/vigencia_porte_anestesico/alterar';
  }
  get urlExcluirVigencia () {
    return this.config.api + '/vigencia_porte_anestesico/excluir/';
  }  
  get urlCancelarVigencia () {
    return this.config.api + '/vigencia_porte_anestesico/cancelar/';
  }  
  get urlDesfazerCancelamentoVigencia () {
    return this.config.api + '/vigencia_porte_anestesico/desfazer_cancelamento/';
  }
  get valorPorteUrl () {
    return this.config.api + '/vigencia_porte_anestesico/consultar_valor/';
  }  
  get urlConsultarFaixasEtarias () {
    return this.config.api + '/faixa_etaria/consultar/';
  }
  get urlExcluirFaixaEtaria () {
    return this.config.api + '/faixa_etaria/excluir';
  }
  get urlAlterarFaixaEtaria () {
    return this.config.api + '/faixa_etaria/alterar';
  }
  get urlIncluirFaixaEtaria () {
    return this.config.api + '/faixa_etaria/incluir';
  }
  get urlValidarFaixaEtaria () {
    return this.config.api + '/faixa_etaria/validar/';
  }
  get urlConsultarTiposMensalidade () {
    return this.config.api + '/tipo_mensalidade/consultar/';
  }
  get urlExcluirTipoMensalidade () {
    return this.config.api + '/tipo_mensalidade/excluir';
  }
  get urlAlterarTipoMensalidade () {
    return this.config.api + '/tipo_mensalidade/alterar';
  }
  get urlIncluirTipoMensalidade () {
    return this.config.api + '/tipo_mensalidade/incluir';
  }
  get mensalidadesUrl () {
    return this.config.api + '/mensalidade/consultar/';
  }
  get valoresMensalidadeUrl () {
    return this.config.api + '/mensalidade/consultar/valores/';
  }
  get urlExcluirMensalidade () {
    return this.config.api + '/mensalidade/excluir';
  }
  get urlConsultarUltimaMensalidade () {
    return this.config.api + '/mensalidade/consultar/ultima_mensalidade';
  }
  get urlIncluirMensalidade () {
    return this.config.api + '/mensalidade/incluir';
  }
  get urlSalvarValorMensalidade () {
    return this.config.api + '/mensalidade/salvar_valor';
  }
  get urlConsultarSeguro () {
    return this.config.api + '/mensalidade/consultar/seguro/';
  }
  get limitesUrl () {
    return this.config.api + '/limite_cobranca/consultar';
  }
  get urlConsultarUltimoLimite () {
    return this.config.api + '/limite_cobranca/consultar/ultimo_limite';
  }
  get urlExcluirLimite () {
    return this.config.api + '/limite_cobranca/excluir';
  }
  get urlAlterarLimite () {
    return this.config.api + '/limite_cobranca/alterar';
  }
  get urlIncluirLimite () {
    return this.config.api + '/limite_cobranca/incluir';
  }
  get urlValidarPrestador () {
    return this.config.api + '/prestador/validar/';
  }
  get urlGuiaAnexo () {
    return this.config.api + '/anexo';
  }
  get urlConsultarNomesTodosProtocolosAcertoMensalidade () {
    return this.config.api + '/acerto_mensalidade/protocolos';
  }
  get urlConsultarOrigensAcertoMensalidade () {
    return this.config.api + '/acerto_mensalidade/origens';
  }
  get urlConsultarEstadosAcertoMensalidade () {
    return this.config.api + '/acerto_mensalidade/estados';
  }
  get urlConsultarAcertosMensalidade () {
    return this.config.api + '/acerto_mensalidade/consultar/';
  }
  get urlIncluirAcerto () {
    return this.config.api + '/acerto_mensalidade/incluir';
  }
  get urlAlterarAcerto () {
    return this.config.api + '/acerto_mensalidade/alterar';
  }
  get urlExcluirAcertos () {
    return this.config.api + '/acerto_mensalidade/excluir_em_lote';
  }
  get urlCancelarAcerto () {
    return this.config.api + '/acerto_mensalidade/cancelar/';
  }
  get urlDesfazerCancelamentoAcerto () {
    return this.config.api + '/acerto_mensalidade/desfazer_cancelamento/';
  }
  get urlAnalisarAcerto () {
    return this.config.api + '/acerto_mensalidade/analisar/';
  }
  get urlExcluirAcerto () {
    return this.config.api + '/acerto_mensalidade/excluir/';
  }
  get urlProcessarAcerto () {
    return this.config.api + '/acerto_mensalidade/processar/';
  }
  get urlConsultarNomesTodosProtocolosAcertoCoparticipacao () {
    return this.config.api + '/acerto_coparticipacao/protocolos';
  }
  get urlConsultarTiposAcertoCoparticipacao () {
    return this.config.api + '/acerto_coparticipacao/tipos';
  }
  get urlConsultarEstadosAcertoCoparticipacao () {
    return this.config.api + '/acerto_coparticipacao/estados';
  }
  get guiasAcertoUrl () {
    return this.config.api + '/acerto_coparticipacao/guias/';
  }
  get demonstrativosAcertoUrl () {
    return this.config.api + '/acerto_coparticipacao/demonstrativos/';
  }
  get urlConsultarAcertosCoparticipacao () {
    return this.config.api + '/acerto_coparticipacao/consultar/';
  }
  get urlConsultarProcedimentos () {
    return this.config.api + '/acerto_coparticipacao/consultar_procedimentos/';
  }
  get urlConsultarProcedimentosPagAntecipado () {
    return this.config.api + '/acerto_coparticipacao/consultar_pag_antecipado/';
  }
  get urlConsultarProcedimentosDevolucao () {
    return this.config.api + '/acerto_coparticipacao/consultar_devolucao/';
  }
  get urlConsultarProcedimentosCopartCalcIncorreto () {
    return this.config.api + '/acerto_coparticipacao/consultar_calc_incorreto/';
  }
  get urlIncluirAcertoCoparticipacao () {
    return this.config.api + '/acerto_coparticipacao/incluir';
  }
  get urlAlterarAcertoCoparticipacao () {
    return this.config.api + '/acerto_coparticipacao/alterar';
  }
  get urlExcluirAcertoCoparticipacao () {
    return this.config.api + '/acerto_coparticipacao/excluir/';
  }
  get urlCancelarAcertoCopart () {
    return this.config.api + '/acerto_coparticipacao/cancelar/';
  }
  get urlDesfazerCancelamentoAcertoCopart () {
    return this.config.api + '/acerto_coparticipacao/desfazer_cancelamento/';
  }
  get urlProcessarAcertoPagAntecipado () {
    return this.config.api + '/acerto_coparticipacao/processar_pag_antecipado/';
  }
  get urlProcessarAcertoDevolucao () {
    return this.config.api + '/acerto_coparticipacao/processar_devolucao/';
  }
  get urlProcessarAcertoCobrancaIndevida () {
    return this.config.api + '/acerto_coparticipacao/processar_cobranca_indevida/';
  }
  get urlAnexarArquivo () {
    return this.config.api + '/acerto_coparticipacao/anexar_arquivo/';
  }
  get consultarArquivosUrl () {
    return this.config.api + '/acerto_coparticipacao/arquivos/';
  }
  get urlDeletarArquivo () {
    return this.config.api + '/acerto_coparticipacao/deletar_arquivo/';
  }
  get urlConsultarNomesTodosProtocolosAcertosDiversos () {
    return this.config.api + '/acertos_diversos/protocolos';
  }
  get urlConsultarAcertosDiversos () {
    return this.config.api + '/acertos_diversos/consultar/';
  }
  get urlIncluirAcertosDiversos () {
    return this.config.api + '/acertos_diversos/incluir';
  }
  get urlAlterarAcertosDiversos () {
    return this.config.api + '/acertos_diversos/alterar';
  }
  get urlExcluirAcertosDiversosEmLote () {
    return this.config.api + '/acertos_diversos/excluir_em_lote';
  }
  get urlExcluirAcertosDiversos () {
    return this.config.api + '/acertos_diversos/excluir/';
  }
  get urlProcessarAcertosDiversos () {
    return this.config.api + '/acertos_diversos/processar/';
  }
  get urlAnexarArquivoCnu () {
    return this.config.api + '/auditoria/elemento/cnu/anexar_arquivo/';
  }
  get consultarArquivosUrlCnu () {
    return this.config.api + '/auditoria/elemento/cnu/arquivos/';
  }
  get urlDeletarArquivoCnu () {
    return this.config.api + '/auditoria/elemento/cnu/deletar_arquivo/';
  }
  get urlConsultarTabelas () {
    return this.config.api + '/item_tabela/consultar/tabela';
  }
  get urlConsultarTiposDeItem () {
    return this.config.api + '/item_tabela/consultar/tipo';
  }
  get urlConsultarItens () {
    return this.config.api + '/item_tabela/consultar/itens/';
  }
  get urlConsultarEventosDividaServDesligado () {
    return this.config.api + '/divida_serv_desligado/eventos';
  }
  get urlConsultarTiposDividaServDesligado () {
    return this.config.api + '/divida_serv_desligado/tipos';
  }  
  get urlConsultarServidoresDesligados () {
    return this.config.api + '/divida_serv_desligado/servidores';
  }
  get urlConsultarDividasServDesligado () {
    return this.config.api + '/divida_serv_desligado/consultar/';
  }
  get urlIncluirDivida () {
    return this.config.api + '/divida_serv_desligado/incluir';
  }
  get urlAlterarDivida () {
    return this.config.api + '/divida_serv_desligado/alterar';
  }
  get urlExcluirDivida () {
    return this.config.api + '/divida_serv_desligado/excluir/';
  }
  get urlCancelarDivida () {
    return this.config.api + '/divida_serv_desligado/cancelar/';
  }
  get urlDesfazerCancelamentoDivida () {
    return this.config.api + '/divida_serv_desligado/desfazer_cancelamento/';
  }  
  get urlValidarDivida () {
    return this.config.api + '/divida_serv_desligado/validar';
  }
  get urlBaixarAutomaticamente () {
    return this.config.api + '/divida_serv_desligado/baixar_automaticamente';
  }
  get urlCompensarCredito () {
    return this.config.api + '/divida_serv_desligado/compensar_credito';
  }
  get urlConsultarTitulares () {
    return this.config.api + '/divida_serv_desligado_pagto/titulares';
  }
  get urlConsultarTitularesComDivida () {
    return this.config.api + '/divida_serv_desligado_pagto/titulares_com_divida';
  }
  get urlConsultarPagtosServDesligado () {
    return this.config.api + '/divida_serv_desligado_pagto/consultar/';
  }
  get urlIncluirPagto () {
    return this.config.api + '/divida_serv_desligado_pagto/incluir';
  }
  get urlAlterarPagto () {
    return this.config.api + '/divida_serv_desligado_pagto/alterar';
  }
  get urlExcluirPagto () {
    return this.config.api + '/divida_serv_desligado_pagto/excluir/';
  }
  get urlCancelarPagto () {
    return this.config.api + '/divida_serv_desligado_pagto/cancelar/';
  }
  get urlDesfazerCancelamentoPagto () {
    return this.config.api + '/divida_serv_desligado_pagto/desfazer_cancelamento/';
  }  
  get urlBaixarPagto () {
    return this.config.api + '/divida_serv_desligado_pagto/baixar_pagto';
  }
  get urlBeneficiariosConsultaGeral () {
    return this.config.api + '/relatorio_beneficiarios/consulta_geral';
  }
  get urlConsultarAnosBase () {
    return this.config.api + '/declaracao_de_gastos/ano_base';
  }
  get urlConsultarDeclaracaoDeGastos () {
    return this.config.api + '/declaracao_de_gastos/consulta_geral/';
  }
  get urlGerarArquivoDeclaracaoDeGastos () {
    return this.config.api + '/declaracao_de_gastos/gerar_arquivo/';
  }  
  get urlGerarArquivoDeclaracaoDeGastosDmed () {
    return this.config.api + '/declaracao_de_gastos/gerar_arquivo_dmed/';
  }  
  get urlConsultarReembolsos () {
    return this.config.api + '/reembolso_medico/consultar/';
  }
  get urlIncluirReembolso () {
    return this.config.api + '/reembolso_medico/incluir';
  }
  get urlAlterarReembolso () {
    return this.config.api + '/reembolso_medico/alterar';
  }
  get urlExcluirReembolso () {
    return this.config.api + '/reembolso_medico/excluir/';
  }  
  get urlConsultarReembolsosPrestador () {
    return this.config.api + '/reembolso_medico/nome_prestador/';
  }  
  get urlConsultarReembolsosOdonto () {
    return this.config.api + '/assistencia_odonto/consultar/';
  }
  get urlIncluirReembolsoOdonto () {
    return this.config.api + '/assistencia_odonto/incluir';
  }
  get urlAlterarReembolsoOdonto () {
    return this.config.api + '/assistencia_odonto/alterar';
  }
  get urlExcluirReembolsoOdonto () {
    return this.config.api + '/assistencia_odonto/excluir/';
  }
  get urlConsultarAnosPericia () {
    return this.config.api + '/assistencia_odonto/anos_pericia';
  }  
  get urlConsultarNumPericias () {
    return this.config.api + '/assistencia_odonto/num_pericias';
  }
  get urlDentistas () {
    return this.config.api + '/assistencia_odonto/dentistas/';
  }    
  get urlConsultarNomeDentista () {
    return this.config.api + '/assistencia_odonto/nome_dentista/';
  }  
  get urlConsultarNomeDentistaReceita () {
    return this.config.api + '/pessoa/prestador/';
  }  
  get urlIncluirDentista () {
    return this.config.api + '/assistencia_odonto/incluir_dentista';
  }
  get urlAlterarDentista () {
    return this.config.api + '/assistencia_odonto/alterar_dentista';
  }
  get urlExcluirDentista () {
    return this.config.api + '/assistencia_odonto/excluir_dentista/';
  }
  get urlConsultarRelatorioReembolso () {
    return this.config.api + '/relatorio_reembolso/consulta_geral/';
  }  
  get urlConsultarSituacaoServidor () {
    return this.config.api + '/dividas_em_aberto/situacao/';
  }
  get urlCarregarDividasEmAberto () {
    return this.config.api + '/dividas_em_aberto/carregar';
  }  
  get urlSalvarGuiaConferida () {
    return this.config.api + '/lote/';
  }  
}
export default Configuracao;
